<template lang="pug">
  .columns
    .column.col-4.pb-2(v-for='(prazo, index) in prazos')
      .input-group
        span.input-group-addon {{index+1}}°
        input.form-input(type='text' placeholder='Dias' v-model='prazo.value' @input='onChangePrazo')
        a.btn.input-group-btn.btn-delete(@click='remove(index)')
          i.form-icon.icon.icon-delete.text-error
    .column.col-3
      a.btn.input-group-btn(@click='add')
        i.form-icon.icon.icon-plus
</template>

<script>
export default {
  props: {
    value: { type: [Array, Object], default: () => [] },
  },
  computed: {
    prazos: {
      get() {
        return Object.keys(this.value)
          .sort()
          .map(p => ({ value: this.value[p] }))
      },

      set(value) {
        const updatedValue = value.reduce(
          (accumulator, item, index) => ({
            ...accumulator,
            [index]: item.value,
          }),
          {},
        )

        this.$emit('input', updatedValue)
      },
    },
  },

  methods: {
    add() {
      this.$set(this, 'prazos', [...this.prazos, { value: null }])
    },
    remove(index) {
      this.$set(
        this,
        'prazos',
        this.prazos.filter((_, i) => i !== index),
      )
    },

    onChangePrazo() {
      this.$set(this, 'prazos', [...this.prazos])
    },
  },
}
</script>

<style lang="stylus" scoped>
.btn-delete
  border-color #e85600
  &:hover, &:focus
    border-color #e85600
    background #fce7db
    box-shadow 0 0 0 0.1rem #fce7db
</style>
